export { default as Logo } from "./logo.svg";
export { default as AdminIcon } from "./admin.svg";
export { default as CloseIcon } from "./close.svg";

export { default as CloudinaryIcon } from "./cloudinary.svg";
export { default as FigmaIcon } from "./figma.svg";
export { default as GithubIcon } from "./github.svg";
export { default as GoogleDriveIcon } from "./google-drive.svg";
export { default as TinaIcon } from "./tina.svg";
export { default as VercelIcon } from "./vercel.svg";
export { default as ResendIcon } from "./resend.svg";
export { default as CalIcon } from "./cal.svg";
